import styles from "./taskfilter.module.css";
import { Link } from "react-router-dom";
import { Plus, Search } from "react-feather";
import { useAuth0 } from "@auth0/auth0-react";

const TaskFilter = ({ setFilterData, setAddTaskModalOpen }) => {
  const { user, isAuthenticated } = useAuth0();

  return (<div className={`${styles.SearchFilterSec}`}>
    <div className={`${styles.SearchCon}`}>
      <div className={`${styles.SearchConSec}`}>
        <Search />
        <input type="text" placeholder="Search" onChange={(e) => setFilterData((prev) => { return { ...prev, searchKey: e.target.value }; })} />
      </div>
    </div>
    <div className={`${styles.FilterSec}`}>
      {isAuthenticated && user["https://propertydek.com/permissions"].indexOf("task:create") > -1 && <Link onClick={(e) => setAddTaskModalOpen(true)} className={`${styles.AddNoteBu}`}>
        <Plus /> <span>Task List</span>
      </Link>}
    </div>
  </div>);
};

export default TaskFilter;